/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Footer from '../components/Footer';

function Addemployee() {

    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [loading, setLoading] = useState(true);
    const [newRecord, setNewRecord] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        dob: "",
        gender: "",
        address: "",
        addressLine1: "",
        city: "",
        zipcode: "",
        state: "",
        country: "",
        jobTitle: "",
        department: "",
        joiningDate: "",
        bankName: "",
        bankAccount: "",
        ifscCode: "",
        panNumber: "",
        aadharNumber: "",
        emergencyContact: "",
    });

    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        dob: "",
        gender: "",
        address: "",
        addressLine1: "",
        city: "",
        zipcode: "",
        state: "",
        country: "",
        jobTitle: "",
        department: "",
        joiningDate: "",
        bankName: "",
        bankAccount: "",
        ifscCode: "",
        aadharNumber: "",
        emergencyContact: "",
    });

    const validateForm = () => {
        let formErrors = {}; // Store validation errors
        const phoneRegex = /^\d{10}$/; // Phone and WhatsApp validation regex (10 digits)


        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.firstName) {
            formErrors.firstName = "First Name is required";
        }

        if (!newRecord.lastName) {
            formErrors.lastName = "Last Name is required";
        }

        if (!newRecord.email) {
            formErrors.email = "Email is required";
        }

        if (!newRecord.phone) {
            formErrors.phone = "Phone is required";
        }


        if (!newRecord.dob) {
            formErrors.dob = "Date Of Birth is required";
        }

        if (!newRecord.gender) {
            formErrors.gender = "Gender is required";
        }

        if (!newRecord.address) {
            formErrors.address = "AddressLine is required";
        }

        if (!newRecord.addressLine1) {
            formErrors.Line1 = "AddressLine1 is required";
        }

        if (!newRecord.city) {
            formErrors.city = "City is required";
        }

        if (!newRecord.zipcode) {
            formErrors.zipcode = "ZipCode is required";
        }

        if (!newRecord.state) {
            formErrors.state = "State is required";
        }

        if (!newRecord.country) {
            formErrors.country = "Country is required";
        }

        if (!newRecord.jobTitle) {
            formErrors.jobTitle = "Job Title is required";
        }

        if (!newRecord.department) {
            formErrors.department = "Department is required";
        }

        if (!newRecord.joiningDate) {
            formErrors.joiningDate = "Date Of Joining is required";
        }

        if (!newRecord.bankName) {
            formErrors.bankName = "Bank Name is required";
        }

        if (!newRecord.bankAccount) {
            formErrors.bankAccount = "Account Number is required";
        }

        if (!newRecord.ifscCode) {
            formErrors.ifscCode = "IFSC Code is required";
        }

        if (!newRecord.aadharNumber) {
            formErrors.aadharNumber = "Aadhar Number is required";
        }

        if (!newRecord.emergencyContact) {
            formErrors.emergencyContact = "Emergency Number is required";
        }

        // Check phone numbers
        if (!phoneRegex.test(newRecord.phone)) {
            formErrors.phone = 'Please enter a valid 10-digit phone number';
        }

        if (!phoneRegex.test(newRecord.emergencyContact)) {
            formErrors.emergencyContact = 'Please enter a valid 10-digit Emergency number';
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    // Handle Form Input Change
    const handleChange = (e) => {
        setNewRecord({ ...newRecord, [e.target.name]: e.target.value });
    };

    const saveEmployee = async (event) => {
        event.preventDefault();

        // Prevent multiple submissions
        if (isSaving || isSaved) return;

        if (validateForm()) {
            setIsSaving(true); // Disable the button

            setLoading(true);
            setErrors({});

            try {

                // Get user ID from localStorage
                const created_by = localStorage.getItem('user_id');

                // Add new fields to formData
                const updatedFormData = {
                    ...newRecord,
                    created_by: created_by,
                    status: true,
                };
                console.log(updatedFormData)
                // Step 1: Save form data to Employee API

                try {
                    const formResponse = await axiosInstance.post('/employee', updatedFormData);
                    console.log(formResponse.data);

                    setIsSaved(true);
                    Swal.fire('Saved!', 'Employee Data saved successfully', 'success');
                    // Navigate without reload
                    navigate("/employee", { replace: true });
                }
                catch (error) {
                    console.error('Error saving data:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error Saving Employee!',
                        text: errorMessage,
                    });
                }
            } catch (error) {
                setErrors((prev) => ({ ...prev, form: error.message }));
            } finally {
                setLoading(false);
            }
            setIsSaving(false); // Re-enable the button
        }
    };


    return (
        <div>
            {/* Page Wrapper */}
            <div class="page-wrapper">
                <div class="content container-fluid">
                    <div class="card mb-0">
                        <div class="card-body">
                            {/* Page Header */}
                            <div class="page-header">
                                <div class="content-page-header">
                                    <h5>Add Employee</h5>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div class="row">
                                <div class="col-md-12">
                                    <form onSubmit={saveEmployee}>
                                        <div class="form-group-item">
                                            <h5 class="form-title">Basic Details</h5>
                                            <div class="row">
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>First Name <span class="text-danger">*</span></label>
                                                        <input type="text" name="firstName" value={newRecord.firstName} onChange={handleChange} class="form-control" placeholder="Enter First Name" />
                                                        {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Last Name <span class="text-danger">*</span></label>
                                                        <input type="text" name="lastName" value={newRecord.lastName} onChange={handleChange} class="form-control" placeholder="Enter Last Name" />
                                                        {errors.lastName && <small className="text-danger">{errors.lastName}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Email <span class="text-danger">*</span></label>
                                                        <input type="email" name="email" value={newRecord.email} onChange={handleChange} class="form-control" placeholder="Enter Email Address" />
                                                        {errors.email && <small className="text-danger">{errors.email}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Phone <span class="text-danger">*</span></label>
                                                        <input type="text" id="mobile_code" name="phone" value={newRecord.phone} onChange={handleChange} class="form-control" placeholder="Phone Number" />
                                                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Date Of Birth <span class="text-danger">*</span></label>
                                                        <input type="Date" name="dob" value={newRecord.dob} onChange={handleChange} class="form-control" placeholder="Enter Date Of Birth" />
                                                        {errors.dob && <small className="text-danger">{errors.dob}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Gender <span class="text-danger">*</span></label>
                                                        <input type="text" name="gender" value={newRecord.gender} onChange={handleChange} class="form-control" placeholder="Enter Gender" />
                                                        {errors.gender && <small className="text-danger">{errors.gender}</small>}
                                                    </div>
                                                </div>                                                
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>AddressLine <span class="text-danger">*</span></label>
                                                        <input type="text" name="address" value={newRecord.address} onChange={handleChange} class="form-control" placeholder="Enter AddressLine" />
                                                        {errors.address && <small className="text-danger">{errors.address}</small>}
                                                    </div>
                                                </div>                                               
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>AddressLine1 <span class="text-danger">*</span></label>
                                                        <input type="text" name="addressLine1" value={newRecord.addressLine1} onChange={handleChange} class="form-control" placeholder="Enter AddressLine1" />
                                                        {errors.addressLine1 && <small className="text-danger">{errors.addressLine1}</small>}
                                                    </div>
                                                </div>                                                                                              
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>City <span class="text-danger">*</span></label>
                                                        <input type="text" name="city" value={newRecord.city} onChange={handleChange} class="form-control" placeholder="Enter City" />
                                                        {errors.city && <small className="text-danger">{errors.city}</small>}
                                                    </div>
                                                </div>                                                                                               
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>ZipCode <span class="text-danger">*</span></label>
                                                        <input type="text" name="zipcode" value={newRecord.zipcode} onChange={handleChange} class="form-control" placeholder="Enter ZipCode" />
                                                        {errors.zipcode && <small className="text-danger">{errors.zipcode}</small>}
                                                    </div>
                                                </div>                                                                                              
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>State <span class="text-danger">*</span></label>
                                                        <input type="text" name="state" value={newRecord.state} onChange={handleChange} class="form-control" placeholder="Enter State" />
                                                        {errors.state && <small className="text-danger">{errors.state}</small>}
                                                    </div>
                                                </div>                                                                                              
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Country <span class="text-danger">*</span></label>
                                                        <input type="text" name="country" value={newRecord.country} onChange={handleChange} class="form-control" placeholder="Enter Country" />
                                                        {errors.country && <small className="text-danger">{errors.country}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Job Title <span class="text-danger">*</span></label>
                                                        <input type="text" name="jobTitle" value={newRecord.jobTitle} onChange={handleChange} class="form-control" placeholder="Enter Job Title" />
                                                        {errors.jobTitle && <small className="text-danger">{errors.jobTitle}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Department <span class="text-danger">*</span></label>
                                                        <input type="text" name="department" value={newRecord.department} onChange={handleChange} class="form-control" placeholder="Enter Department" />
                                                        {errors.department && <small className="text-danger">{errors.department}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Date Of Joining <span class="text-danger">*</span></label>
                                                        <input type="Date" name="joiningDate" value={newRecord.joiningDate} onChange={handleChange} class="form-control" placeholder="Enter Date Of Joining" />
                                                        {errors.joiningDate && <small className="text-danger">{errors.joiningDate}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Pan Number</label>
                                                        <input type="text" class="form-control" placeholder="Enter Pan Number" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Aadhar Number <span class="text-danger">*</span></label>
                                                        <input type="text" name="aadharNumber" value={newRecord.aadharNumber} onChange={handleChange} class="form-control" placeholder="Enter Aadhar Number" />
                                                        {errors.aadharNumber && <small className="text-danger">{errors.aadharNumber}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Emergency Contact <span class="text-danger">*</span></label>
                                                        <input type="text" name="emergencyContact" value={newRecord.emergencyContact} onChange={handleChange} class="form-control" placeholder="Enter Emergency Contact" />
                                                        {errors.emergencyContact && <small className="text-danger">{errors.emergencyContact}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group-customer customer-additional-form">
                                            <div class="row">
                                                <h5 class="form-title">Bank Details <span class="text-danger">*</span></h5>
                                                <div class="col-lg-4 col-md-6 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Bank Name</label>
                                                        <input type="text" name="bankName" value={newRecord.bankName} onChange={handleChange} class="form-control" placeholder="Enter Bank Name" />
                                                        {errors.bankName && <small className="text-danger">{errors.bankName}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-12 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>Account Number <span class="text-danger">*</span></label>
                                                        <input type="text" name="bankAccount" value={newRecord.bankAccount} onChange={handleChange} class="form-control" placeholder="Enter Account Number" />
                                                        {errors.bankAccount && <small className="text-danger">{errors.bankAccount}</small>}
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 col-md-12 col-sm-12">
                                                    <div class="input-block mb-3">
                                                        <label>IFSC <span class="text-danger">*</span></label>
                                                        <input type="text" name="ifscCode" value={newRecord.ifscCode} onChange={handleChange} class="form-control" placeholder="Enter IFSC Code" />
                                                        {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-customer-btns text-end">
                                            <a href="/employee" class="btn customer-btn-cancel">Cancel</a>
                                            <button type="submit" class="btn customer-btn-save" disabled={isSaving || isSaved}>{isSaved ? 'Employee Saved' : isSaving ? 'Saving...' : 'Save Employee'} </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            {/* /Page Wrapper */}
        </div>
    )
}

export default Addemployee